import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=b94b04fe&scoped=true"
import script from "./Loads.vue?vue&type=script&lang=ts"
export * from "./Loads.vue?vue&type=script&lang=ts"
import style0 from "./Loads.vue?vue&type=style&index=0&id=b94b04fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b04fe",
  null
  
)

export default component.exports